import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from './store';
import en from '@/locales/en.json';
import es from '@/locales/es.json';

import { Trans } from '@/plugins/Translation';
import ConfigService from '@/services/config.service';

const defaultImpl = VueI18n.prototype.getChoiceIndex;

VueI18n.prototype.getChoiceIndex = function getChoiceIndex(choice, choicesLength) {
    // this === VueI18n instance, so the locale property also exists here
    // if (this.locale !== 'ru') {
    // // proceed to the default implementation
    //     return defaultImpl.apply(this, arguments);
    // }

    if (choice === 0) {
        return 0;
    }

    const teen = choice > 10 && choice < 20;
    const endsWithOne = choice % 10 === 1;

    if (!teen && endsWithOne) {
        return 1;
    }

    if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
    }

    return choicesLength < 4 ? 2 : 3;
};

Vue.use(VueI18n);

const dateTimeFormats = {
    'en': {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }
    },
    'es': {
        short: {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }
    }
};

const numberFormats = {
    'en': {
        currency: {
            style: 'currency', currency: 'USD'
        }
    },
    'es': {
        currency: {
            style: 'currency', currency: 'UYU'
        }
    }
};

ConfigService.getLocalConfig().then(
    response => {
        if (response.data.selected) {
            return Trans.changeLocale(response.data.selected).then(() => {
                // we should PERSIST this data.
                store.dispatch('settings/changeSetting', {
                    key: 'locale',
                    value: response.data.selected
                });
            });
        }
    },
    error => {
        console.log(error.response && error.response.data ||
  error.message || error.toString());
    }
);

export const i18n = new VueI18n({
    locale: store.state.settings.locale || process.env.VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: { en, es },
    dateTimeFormats,
    numberFormats
});
